var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerConnectivityLiveview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.3435L14.5 8.84351L7.5 4.34351V13.3435ZM6 18.8435V16.8435H2C1.45 16.8435 0.979167 16.6477 0.5875 16.256C0.195833 15.8643 0 15.3935 0 14.8435V2.84351C0 2.29351 0.195833 1.82267 0.5875 1.43101C0.979167 1.03934 1.45 0.843506 2 0.843506H18C18.55 0.843506 19.0208 1.03934 19.4125 1.43101C19.8042 1.82267 20 2.29351 20 2.84351V14.8435C20 15.3935 19.8042 15.8643 19.4125 16.256C19.0208 16.6477 18.55 16.8435 18 16.8435H14V18.8435H6ZM2 14.8435H18V2.84351H2V14.8435Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerConnectivityLiveview);
export default __webpack_public_path__ + "static/media/tower_connectivity_liveview.10e2798b716f8116f722226903f4fa22.svg";
export { ForwardRef as ReactComponent };